import React, { useCallback } from 'react';
import { fetchPendingCourses } from '../../../util/FetchCourseData';
import PendingCourseCard from '../../cards/course-cards/PendingCourseCard';
import GenericPanel from '../GenericPanel';
import { useAdminPanel } from '../useAdminPanel';

const PendingCoursesPanel = ({
    numberOfPendingCourses,
    handleUnauthorized,
    onCourseStatusUpdated,
}) => {
    // Use our custom hook for data fetching and infinite scrolling
    const {
        loading,
        data: pendingCourses,
        hasMoreItems,
        loadMore,
        removeItem,
    } = useAdminPanel(
        fetchPendingCourses,
        numberOfPendingCourses,
        handleUnauthorized,
    );

    // Handle course removal from UI
    const handleRemoveCourse = useCallback(
        (courseId) => {
            removeItem(courseId, 'course_id');

            // Notify parent component to update the count
            if (onCourseStatusUpdated) {
                onCourseStatusUpdated();
            }
        },
        [removeItem, onCourseStatusUpdated],
    );

    // Render each course card
    const renderCourse = (course) => (
        <PendingCourseCard
            key={course.course_id}
            course={course}
            onRemove={handleRemoveCourse}
        />
    );

    return (
        <GenericPanel
            loading={loading}
            data={pendingCourses}
            hasMoreItems={hasMoreItems}
            onLoadMore={loadMore}
            renderItem={renderCourse}
            className="pending-courses-container"
        />
    );
};

export default PendingCoursesPanel;
